import React, { useEffect } from 'react';
import { useAppDispatch, useAppState } from 'store/configureStore';
import { toolbarIntegrationInit } from '../store/action/toolbar/toolbarIntegration';

const GlobalToolbarIntegrationInit: React.FC = () => {
  const state = useAppState();
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.transcriptionSummariserFrontendIntegration = toolbarIntegrationInit(
      dispatch,
      () => state,
    );
  }, [dispatch, state]);

  return null;
};

export default GlobalToolbarIntegrationInit;
